{
  "label": "Weather stations",
  "on": "Show",
  "off": "Hide",
  "help": "How to read weather stations",
  "legend": {
    "mouse": "Circles show the wind in {{unit}}, coloured from calm to {{max}}+. A small +4 means gusts 4 {{unit}} stronger. The notch points downwind. Click a station for details.",
    "touch": "Circles show the wind in {{unit}}, coloured from calm to {{max}}+. A small +4 means gusts 4 {{unit}} stronger. The notch points downwind. Tap a station for details."
  },
  "details": {
    "wind": "Wind",
    "windFrom": "{{speed}} from {{dir}}",
    "gust": "Gusts",
    "temperature": "Temperature",
    "densityAltitude": "Density altitude",
    "precipitation": "Precipitation",
    "elevation": "Elevation",
    "coordinates": "Coordinates",
    "estimated": "≈ {{value}}"
  },
  "precip": {
    "kind": {
      "rain": "rain",
      "drizzle": "drizzle",
      "freezingRain": "freezing rain",
      "snow": "snow",
      "icePellets": "ice pellets",
      "hail": "hail",
      "unknown": "precipitation"
    },
    "intensity": {
      "light": "light {{what}}",
      "moderate": "{{what}}",
      "heavy": "heavy {{what}}"
    },
    "thunder": "thunder",
    "lastHour": "{{amount}} (1 h)",
    "none": "None",
    "noneLastHour": "None in the past hour"
  },
  "errors": {
    "noToken": "Weather stations need a Synoptic API token (VITE_SYNOPTIC_TOKEN).",
    "token": "The Synoptic API rejected the token.",
    "service": "Couldn't load weather stations. Trying again as you move the map."
  }
}
